import {ApiConsumer} from '@eitje/api'
import {ApiConsumersAdvancedTable, Filters, PageLayout} from '~/components'
import {ApiConsumersPageHeader} from './page_header'

export const ApiConsumers = () => {
	const apiConsumers = ApiConsumer.useAll()

	return (
		<PageLayout
			name="api_consumers"
			headers={[<ApiConsumersPageHeader key="page-header" />, <Filters key="filters" />]}
			filterProps={{
				items: apiConsumers,
				filters: ['apiConsumerPartnerUsername'],
			}}
		>
			<ApiConsumersAdvancedTable />
		</PageLayout>
	)
}
